import { call, put } from 'redux-saga/effects';

import { fetchAttachment } from '@api/messages';
import { toastError } from '@store/notifications';

export const handleFetchAttachment = function* ({ payload }) {
  try {
    const handleFetchAttachmentResponse = yield call(fetchAttachment, payload.attachmentId);

    const linkUrl = document.createElement('a');
    linkUrl.href = handleFetchAttachmentResponse.url;
    document.body.appendChild(linkUrl);
    linkUrl.click();
    document.body.removeChild(linkUrl);
  } catch (error) {
    yield put(
      toastError({
        message: error.data?.nonFieldErrors || {
          defaultMessage: 'An unexpected error occurred, please try again.',
          id: 'global.notification.api-error-default',
        },
      })
    );
  }
};
